// src/app/components/social-share/social-share.component.ts
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-social-share',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './social-share.component.html',
  styleUrls: ['./social-share.component.css'],
})
export class SocialShareComponent {
  @Input() title: string = 'Lydia Christensen for U.S. Senate';
  @Input() url: string = '';

  copied = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  get shareUrl(): string {
    if (this.url) return this.url;
    return isPlatformBrowser(this.platformId) ? window.location.href : '';
  }

  get encodedUrl(): string {
    return encodeURIComponent(this.shareUrl);
  }

  get encodedTitle(): string {
    return encodeURIComponent(this.title);
  }

  shareOnFacebook(): void {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}`, '_blank', 'width=600,height=400');
  }

  shareOnX(): void {
    window.open(`https://x.com/intent/tweet?text=${this.encodedTitle}&url=${this.encodedUrl}`, '_blank', 'width=600,height=400');
  }

  shareOnBluesky(): void {
    window.open(`https://bsky.app/intent/compose?text=${this.encodedTitle}%20${this.encodedUrl}`, '_blank', 'width=600,height=400');
  }

  copyLink(): void {
    navigator.clipboard.writeText(this.shareUrl).then(() => {
      this.copied = true;
      setTimeout(() => this.copied = false, 2000);
    });
  }
}
